// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1v_S4","col":"styles_col__7ygH3","fulfillmentStatus":"styles_fulfillmentStatus__1fVrR","emailCol":"styles_emailCol__3Ga7w"};